import React from "react";
import ExcelJS from "exceljs";
import { toast } from "react-toastify";

export const ExportRolesExcel = ({ filteredData }) => {
    const exportToExcel = async () => {
        try {
            // Use filteredData if provided, otherwise fetch all roles
            let rolesData = filteredData;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Roles");

            // Define styles
            const boldFont = { bold: true };

            // Get current date and time
            const currentDate = new Date();
            const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
            const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
            const downloadDateTime = `Role Details Generated on: ${formattedDate}, ${formattedTime}`;

            // Add the downloadDateTime to the worksheet
            worksheet.addRow(["", "", downloadDateTime, ""]);
            worksheet.mergeCells(1, 2, 1, 5);
            worksheet.getCell(1, 2).value = downloadDateTime;
            worksheet.getCell(1, 2).font = boldFont;
            worksheet.getCell(1, 2).alignment = { horizontal: "center" };

            // Add filter information if filtered data is used
            let rowIndex = 2;
            if (filteredData && filteredData.length > 0) {
                worksheet.addRow(["", "", "Roles", ""]);
                worksheet.mergeCells(rowIndex, 2, rowIndex, 5);
                worksheet.getCell(rowIndex, 2).value = "Roles";
                worksheet.getCell(rowIndex, 2).font = boldFont;
                worksheet.getCell(rowIndex, 2).alignment = { horizontal: "center" };
                rowIndex++;
            } else {
                worksheet.addRow(["", "", "All Roles", ""]);
                worksheet.mergeCells(rowIndex, 2, rowIndex, 5);
                worksheet.getCell(rowIndex, 2).value = "All Roles";
                worksheet.getCell(rowIndex, 2).font = boldFont;
                worksheet.getCell(rowIndex, 2).alignment = { horizontal: "center" };
                rowIndex++;
            }

            // Define table headers
            const tableHeaderRow = worksheet.addRow([
                "S.No",
                "Role Name",
                "Role Code",
                "Status",
            ]);
            
            tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.font = boldFont;
                cell.alignment = { horizontal: "center" };
                if (colNumber >= 1 && colNumber <= 5) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "F6B1B1" }, // Background color
                        bgColor: { argb: "FFFFFFFF" } // Text color
                    };
                }
            });

            // Add data rows
            rolesData.forEach((role, index) => {
                const createdDate = role.createdDate ? new Date(role.createdDate).toLocaleDateString() : "N/A";
                
                worksheet.addRow([
                    index + 1,
                    role.roleName || "N/A",
                    role.roleCode || "N/A",
                    role.isActive ? "Active" : "InActive",
                ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    cell.alignment = { horizontal: "center" };
                });
            });

            // Set column widths dynamically based on content
            worksheet.columns = [
                { width: 5 },     // S.No
                { width: 25 },    // Role Name
                { width: 20 },    // Role Code
                { width: 20 },    // Created Date
                { width: 15 },    // Status
            ];

            // Save the workbook to a file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Roles.xlsx`;
            a.click();
            URL.revokeObjectURL(url);

            
        } catch (error) {
            console.error("Error generating Excel file:", error);
            toast.error("Error exporting roles data", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    return (
        <button
            className="button-container"
            onClick={exportToExcel}
        >
            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
            Excel
        </button>
    );
};